/* eslint-disable */
import React, { PropTypes } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import { Modal, Button, Col, Row, Well, HelpBlock } from 'react-bootstrap';
import { TextField, ReadOnlyField } from './AdminComponents';
import { browserHistory } from 'react-router';
import Select from 'react-select';
import Dropzone from 'react-dropzone';

const lang = 'zh-tw'

export default class AdminManageAccountAuthorityCt extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			is_loaded: false,
			authority_data: [],
			is_merge_translation: false
		}

		this.onSubmit = this.onSubmit.bind(this)
	}

	componentDidMount() {

		const { params } = this.props

		// route.type === 'edit' ? this.loadData( params.email ) : this.onMerge()

		this.loadData(params.user_id)
	}

	componentWillReceiveProps(nextProps) {

	}

	componentDidUpdate() {
		const { is_loaded_translation_data, translation_data } = this.props;
		const { is_loaded, is_merge_translation_data, authority_data } = this.state;

		if (is_loaded_translation_data && is_loaded && !is_merge_translation_data) {

			// authority_data.map((x, y)=> _.merge( x, _.find( translation_data, { id: x.front_name_key } ) ))

			// 暫時用
			authority_data.map((x, y) => {

				return _.merge(x, _.find(translation_data, { id: '1' }))
			})

			// 排列
			let order_authority_data = _.orderBy(authority_data, 'front_name', 'desc')

			this.setState({ authority_data: order_authority_data, is_merge_translation_data: true })
		}

		// const { is_loaded_role_data, is_loaded_usergroup_data } = this.props
		// const { is_loaded, is_merge_role_data, is_merge_usergroup_data, role_data, usergroup_data, role_id, group_id, is_merge_role_option, is_merge_group_option } = this.state

		// //	簡易判斷
		// if ( !is_merge_role_data && !is_merge_usergroup_data && is_loaded_role_data && is_loaded_usergroup_data ) {

		// 	this.onMerge()
		// }

		// //  合併id成option
		// if ( is_loaded && is_merge_role_data && is_loaded_usergroup_data && !is_merge_role_option && !is_merge_group_option ) {

		// 	let role_option = _.find( role_data, { value: role_id } )
		// 	role_option = role_option === undefined ? {} : role_option

		// 	let group_option = _.find( usergroup_data, { value: group_id } )
		// 	group_option = group_option === undefined ? {} : group_option

		// 	this.setState({ role_option: role_option, group_option: group_option, is_merge_role_option: true, is_merge_role_option: true })
		// }
	}

	loadData(user_id) {

		$.ajax({
			type: 'get',
			url: '/api/W_SkyFamily_User_Front_Permission_Get.php?user_id=' + user_id,
			success: response => {
				let data = []
				if (response.status === '0') {

					data = response.result
				}
				else alert(response.msg)

				this.setState({ authority_data: response.result, is_loaded: true })
			},
			error: (xhr, ajaxOptions, thrownError) => { },
		});
	}

	onChangeAuthority(value, index) {

		const { authority_data } = this.state

		authority_data[index]['permission'] = value
		this.setState({ authority_data: authority_data })
	}

	onSubmit() {
		const { params, closeModal } = this.props
		const { authority_data } = this.state

		let front_name_permission_list = ''
		authority_data.map((x, y) => front_name_permission_list += x.front_name + "," + x.permission + "|")
		front_name_permission_list = front_name_permission_list.substr(0, (front_name_permission_list.length - 1))

		let formData = new FormData()
		formData.append('user_id', params.user_id)
		formData.append('front_name_permission_list', front_name_permission_list)

		$.ajax({
			type: 'post',
			url: '/api/W_SkyFamily_User_Front_Permission_Update.php',
			data: formData,
			processData: false,
			contentType: false,
			success: response => {
				this.setState({ is_loaded: true })

				if (response.status === '0') {//成功

					alert('儲存成功')
					closeModal()
				}
				else { alert(response.msg) }
			},
			error: error => { },
			beforeSend: () => this.setState({ is_loaded: false }),
		});
	}

	render() {

		const { closeModal } = this.props;
		const {
			is_loaded,
			authority_data
		} = this.state

		const loading = is_loaded ? null : <div className="loading"><img role="presentation" src="/imgs/loading.gif" /></div>

		return (
			<div>
				<Modal
					show={true}
					bsSize="large"
					className="div-newsCt"
					keyboard={false}
					backdrop="static"
					id="admin"
				// onHide={closeModal}
				>
					<Modal.Header>
						<Modal.Title>權限管理</Modal.Title>
						<span className="span-newsModalBtn">
							<Button onClick={this.onSubmit}>儲存</Button>
							<Button onClick={closeModal}>關閉</Button>
						</span>
					</Modal.Header>
					<Modal.Body>
						{
							authority_data.map((x, y) => {

								return (
									<Row key={y}>
										<Col sm={8}>
											<div style={{ fontWeight: "bold" }}>{x.front_name}</div>
										</Col>
										<Col sm={4}>
											<select className="form-control" value={x.permission} onChange={(e) => this.onChangeAuthority(e.target.value, y)} >
												<option value="1">無權限</option>
												<option value="3">完全權限</option>
											</select>
										</Col>
									</Row>
								)
							})
						}
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.onSubmit}>儲存</Button>
						<Button onClick={closeModal}>關閉</Button>
					</Modal.Footer>
				</Modal>
				{loading}
			</div>
		);
	}
}





// WEBPACK FOOTER //
// ./src/salesky/routes/admin/AdminManageAccountAuthorityCt.jsx